/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Assign_Driver_Badge_BusyInputs */

const vi_assign_driver_badge_busy = /** @type {(inputs: Assign_Driver_Badge_BusyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Đang giao ${i?.count} đơn`)
};

/**

* @param {Assign_Driver_Badge_BusyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const assign_driver_badge_busy = /** @type {((inputs: Assign_Driver_Badge_BusyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_Driver_Badge_BusyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_assign_driver_badge_busy(inputs)
});